import EmptyState from '@/components/EmptyState'
import { useBrandStats } from '@/hooks/useBrandStats'
import { ArrowUpRight } from '@mynaui/icons-react'
import { Link } from '@tanstack/react-router'

type BrandCollectionDataProps = {
  data: BrandDataProps[]
}

export type BrandDataProps = {
  brandImage: string | null
  brandName: string
  fbPageId: string
  // totalAdCount: number;
  // totalEmailCount: number;
  // totalLanderCount: number;
  // totalActiveAdCount: number;
  brandId: string
}

export const BrandsGridView = ({ data }: BrandCollectionDataProps) => {
  return data && data.length > 0 ? (
    <div className={'grid grid-cols-1 lg:grid-cols-2 gap-x-6'}>
      {data.map((item) => (
        <Link key={item.brandName} to={`/feeds/brands/$brandID`} params={{ brandID: item.fbPageId }}>
          <BrandCard data={item} />
        </Link>
      ))}
    </div>
  ) : (
    <EmptyState
      text=" Looks like you've gone down a path with no brands...this is your fault!
          All we do is win...but really, maybe try a different search term!"
    />
  )
}

const BrandCard = ({ data }: { data: BrandDataProps }) => {
  const { brandStatData } = useBrandStats(data.brandId)

  return (
    <div
      className={
        'px-2 py-3 flex justify-between items-start gap-5 w-full border-t border-themeborder dark:border-darkthemeinput hover:bg-themeaccent dark:hover:bg-themeaccentdark'
      }
    >
      <div>
        <div className={'flex gap-3 lg:items-center'}>
          <img
            className={'rounded-xl w-12 h-12 bg-themeaccent'}
            src={data.brandImage ? data.brandImage : '/bg_gradient.jpg'}
            alt={data.brandName}
          />
          <div>
            <p className={'text-base lg:text-lg'}>{data.brandName}</p>
            {brandStatData ? (
              <div className={'flex gap-3'}>
                {brandStatData.totalAdCount > 0 ? (
                  <span className={'text-xs text-thememutedforeground'}>{brandStatData.totalAdCount} Total Ads</span>
                ) : null}
                {brandStatData.totalEmailCount > 0 ? (
                  <span className={'text-xs text-thememutedforeground'}>
                    {brandStatData.totalEmailCount} Total Emails
                  </span>
                ) : null}
                {brandStatData.totalLanderCount > 0 ? (
                  <span className={'text-xs text-thememutedforeground'}>
                    {brandStatData.totalLanderCount} Total Landers
                  </span>
                ) : null}
                {brandStatData.totalActiveAdCount > 0 ? (
                  <span className={'text-xs text-thememutedforeground'}>
                    {brandStatData.totalActiveAdCount} Ads Running Now
                  </span>
                ) : null}
              </div>
            ) : null}
            <div className={'flex lg:hidden mt-[0.625rem] items-center gap-10'}>
              <div className={'flex gap-3 items-start text-thememutedforeground hover:underline'}>
                <span className={'text-xs'}>View Ads</span>
                <ArrowUpRight className={'w-5 h-5'} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={'hidden lg:flex items-center gap-2'}>
        <div className={'flex gap-2 items-center text-thememutedforeground hover:underline'}>
          <span className={'text-xs'}>View Ads</span>
          <ArrowUpRight className={'w-5 h-5'} />
        </div>
      </div>
    </div>
  )
}
